// extracted by mini-css-extract-plugin
module.exports = {"listItem":"SideBarItem_listItem__3sWkl","link":"SideBarItem_link__1YH09","icon":"SideBarItem_icon__2Ubeh"};